import { motion, useReducedMotion } from "framer-motion";
import styles from "@styles/site.module.css";

export type TerminalLine = {
  text: string;
  kind?: "cmd" | "ok" | "muted" | "out";
};

const kindClass: Record<NonNullable<TerminalLine["kind"]>, string | undefined> = {
  cmd: styles.terminalLineCmd,
  ok: styles.terminalLineOk,
  muted: styles.terminalLineMuted,
  out: styles.terminalLine,
};

export function AnimatedTerminal({ title, lines }: { title: string; lines: TerminalLine[] }) {
  const reduce = useReducedMotion();
  return (
    <div className={styles.terminal}>
      <div className={styles.terminalBar}>{title}</div>
      <div className={styles.terminalBody}>
        {lines.map((line, i) => (
          <motion.span
            key={`${i}-${line.text}`}
            className={`${styles.terminalLine} ${kindClass[line.kind ?? "out"] ?? ""}`}
            initial={reduce ? false : { opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.25, delay: reduce ? 0 : 0.3 + i * 0.16 }}
          >
            {line.text}
          </motion.span>
        ))}
        <span className={styles.cursor} aria-hidden="true" />
      </div>
    </div>
  );
}
